export const APARTMENT_RENTALS = [
  {
    title: 'Austin apartments for rent',
    url: '/austin-tx/apartments-for-rent',
  },
  {
    title: 'Boston apartments for rent',
    url: '/boston-ma/apartments-for-rent',
  },
  {
    title: 'Brooklyn NYC apartments for rent',
    url: '/brooklyn-new-york-ny/apartments-for-rent',
  },
  {
    title: 'Chicago apartments for rent',
    url: '/chicago-il/apartments-for-rent',
  },
  {
    title: 'Cincinnati apartments for rent',
    url: '/cincinnati-oh/apartments-for-rent',
  },
  {
    title: 'Fort Worth apartments for rent',
    url: '/fort-worth-tx/apartments-for-rent',
  },
  {
    title: 'Indianapolis apartments for rent',
    url: '/indianapolis-in/apartments-for-rent',
  },
  {
    title: 'Jacksonville apartments for rent',
    url: '/jacksonville-fl/apartments-for-rent',
  },
  {
    title: 'Jersey City apartments for rent',
    url: '/jersey-city-nj/apartments-for-rent',
  },
  {
    title: 'Las Vegas apartments for rent',
    url: '/las-vegas-nv/apartments-for-rent',
  },
  {
    title: 'Los Angeles apartments for rent',
    url: '/los-angeles-ca/apartments-for-rent',
  },
  {
    title: 'Miami apartments for rent',
    url: '/miami-fl/apartments-for-rent',
  },
  {
    title: 'Nashville apartments for rent',
    url: '/nashville-tn/apartments-for-rent',
  },
  {
    title: 'New York City apartments for rent',
    url: '/new-york-ny/apartments-for-rent',
  },
  {
    title: 'Newark apartments for rent',
    url: '/newark-nj/apartments-for-rent',
  },
  {
    title: 'Oakland apartments for rent',
    url: '/oakland-ca/apartments-for-rent',
  },
  {
    title: 'Philadelphia apartments for rent',
    url: '/philadelphia-pa/apartments-for-rent',
  },
  {
    title: 'Phoenix apartments for rent',
    url: '/phoenix-az/apartments-for-rent',
  },
  {
    title: 'Pittsburgh apartments for rent',
    url: '/pittsburgh-pa/apartments-for-rent',
  },
  {
    title: 'Portland apartments for rent',
    url: '/portland-or/apartments-for-rent',
  },
  {
    title: 'Queens NYC apartments for rent',
    url: '/queens-new-york-ny/apartments-for-rent',
  },
  {
    title: 'San Antonio apartments for rent',
    url: '/san-antonio-tx/apartments-for-rent',
  },
  {
    title: 'San Francisco apartments for rent',
    url: '/san-francisco-ca/apartments-for-rent',
  },
  {
    title: 'Seattle apartments for rent',
    url: '/seattle-wa/apartments-for-rent',
  },
  {
    title: 'Washington DC apartments for rent',
    url: '/washington-dc/apartments-for-rent',
  },
];

export const HOUSE_RENTALS = [
  {
    title: 'Atlanta houses for rent',
    url: '/atlanta-ga/houses-for-rent',
  },
  {
    title: 'Baltimore houses for rent',
    url: '/baltimore-md/houses-for-rent',
  },
  {
    title: 'Charlotte houses for rent',
    url: '/charlotte-nc/houses-for-rent',
  },
  {
    title: 'Chicago houses for rent',
    url: '/chicago-il/houses-for-rent',
  },
  {
    title: 'Cleveland houses for rent',
    url: '/cleveland-oh/houses-for-rent',
  },
  {
    title: 'Columbus houses for rent',
    url: '/columbus-oh/houses-for-rent',
  },
  {
    title: 'Dallas houses for rent',
    url: '/dallas-tx/houses-for-rent',
  },
  {
    title: 'Detroit houses for rent',
    url: '/detroit-mi/houses-for-rent',
  },
  {
    title: 'Greensboro houses for rent',
    url: '/greensboro-nc/houses-for-rent',
  },
  {
    title: 'Houston houses for rent',
    url: '/houston-tx/houses-for-rent',
  },
  {
    title: 'Indianapolis houses for rent',
    url: '/indianapolis-in/houses-for-rent',
  },
  {
    title: 'Jacksonville houses for rent',
    url: '/jacksonville-fl/houses-for-rent',
  },
  {
    title: 'Kansas City houses for rent',
    url: '/kansas-city-mo/houses-for-rent',
  },
  {
    title: 'Las Vegas houses for rent',
    url: '/las-vegas-nv/houses-for-rent',
  },
  {
    title: 'Los Angeles houses for rent',
    url: '/los-angeles-ca/houses-for-rent',
  },
  {
    title: 'Louisville houses for rent',
    url: '/louisville-ky/houses-for-rent',
  },
  {
    title: 'Memphis houses for rent',
    url: '/memphis-tn/houses-for-rent',
  },
  {
    title: 'Omaha houses for rent',
    url: '/omaha-ne/houses-for-rent',
  },
  {
    title: 'Philadelphia houses for rent',
    url: '/philadelphia-pa/houses-for-rent',
  },
  {
    title: 'Phoenix houses for rent',
    url: '/phoenix-az/houses-for-rent',
  },
  {
    title: 'Richmond houses for rent',
    url: '/richmond-va/houses-for-rent',
  },
  {
    title: 'Sacramento houses for rent',
    url: '/sacramento-ca/houses-for-rent',
  },
  {
    title: 'Saint Louis houses for rent',
    url: '/saint-louis-mo/houses-for-rent',
  },
  {
    title: 'San Diego houses for rent',
    url: '/san-diego-ca/houses-for-rent',
  },
  {
    title: 'Washington DC houses for rent',
    url: '/washington-dc/houses-for-rent',
  },
];

export const FOR_RENT_BY_OWNER = [
  {
    title: 'Atlanta Private Landlord rentals',
    url: '/atlanta-ga/for-rent-by-owner',
  },
  {
    title: 'Augusta Private Landlord rentals',
    url: '/augusta-ga/for-rent-by-owner',
  },
  {
    title: 'Baltimore Private Landlord rentals',
    url: '/baltimore-md/for-rent-by-owner',
  },
  {
    title: 'Charlotte Private Landlord rentals',
    url: '/charlotte-nc/for-rent-by-owner',
  },
  {
    title: 'Chicago Private Landlord rentals',
    url: '/chicago-il/for-rent-by-owner',
  },
  {
    title: 'Columbia Private Landlord rentals',
    url: '/columbia-sc/for-rent-by-owner',
  },
  {
    title: 'Dallas Private Landlord rentals',
    url: '/dallas-tx/for-rent-by-owner',
  },
  {
    title: 'Detroit Private Landlord rentals',
    url: '/detroit-mi/for-rent-by-owner',
  },
  {
    title: 'Greensboro Private Landlord rentals',
    url: '/greensboro-nc/for-rent-by-owner',
  },
  {
    title: 'Houston Private Landlord rentals',
    url: '/houston-tx/for-rent-by-owner',
  },
  {
    title: 'Indianapolis Private Landlord rentals',
    url: '/indianapolis-in/for-rent-by-owner',
  },
  {
    title: 'Jacksonville Private Landlord rentals',
    url: '/jacksonville-fl/for-rent-by-owner',
  },
  {
    title: 'Las Vegas Private Landlord rentals',
    url: '/las-vegas-nv/for-rent-by-owner',
  },
  {
    title: 'Memphis Private Landlord rentals',
    url: '/memphis-tn/for-rent-by-owner',
  },
  {
    title: 'Orlando Private Landlord rentals',
    url: '/orlando-fl/for-rent-by-owner',
  },
  {
    title: 'Philadelphia Private Landlord rentals',
    url: '/philadelphia-pa/for-rent-by-owner',
  },
  {
    title: 'Phoenix Private Landlord rentals',
    url: '/phoenix-az/for-rent-by-owner',
  },
  {
    title: 'Raleigh Private Landlord rentals',
    url: '/raleigh-nc/for-rent-by-owner',
  },
  {
    title: 'Richmond Private Landlord rentals',
    url: '/richmond-va/for-rent-by-owner',
  },
  {
    title: 'Saint Louis Private Landlord rentals',
    url: '/saint-louis-mo/for-rent-by-owner',
  },
  {
    title: 'San Antonio Private Landlord rentals',
    url: '/san-antonio-tx/for-rent-by-owner',
  },
  {
    title: 'Tampa Private Landlord rentals',
    url: '/tampa-fl/for-rent-by-owner',
  },
  {
    title: 'Tucson Private Landlord rentals',
    url: '/tucson-az/for-rent-by-owner',
  },
  {
    title: 'Virginia Beach Private Landlord rentals',
    url: '/virginia-beach-va/for-rent-by-owner',
  },
  {
    title: 'Washington DC Private Landlord rentals',
    url: '/washington-dc/for-rent-by-owner',
  },
];

export const STATE_RENTALS = [
  {
    title: 'Alabama',
    url: '/alabama',
  },
  {
    title: 'Alaska',
    url: '/alaska',
  },
  {
    title: 'Arizona',
    url: '/arizona',
  },
  {
    title: 'Arkansas',
    url: '/arkansas',
  },
  {
    title: 'California',
    url: '/california',
  },
  {
    title: 'Colorado',
    url: '/colorado',
  },
  {
    title: 'Connecticut',
    url: '/connecticut',
  },
  {
    title: 'Delaware',
    url: '/delaware',
  },
  {
    title: 'Florida',
    url: '/florida',
  },
  {
    title: 'Georgia',
    url: '/georgia',
  },
  {
    title: 'Hawaii',
    url: '/hawaii',
  },
  {
    title: 'Idaho',
    url: '/idaho',
  },
  {
    title: 'Illinois',
    url: '/illinois',
  },
  {
    title: 'Indiana',
    url: '/indiana',
  },
  {
    title: 'Iowa',
    url: '/iowa',
  },
  {
    title: 'Kansas',
    url: '/kansas',
  },
  {
    title: 'Kentucky',
    url: '/kentucky',
  },
  {
    title: 'Louisiana',
    url: '/louisiana',
  },
  {
    title: 'Maine',
    url: '/maine',
  },
  {
    title: 'Maryland',
    url: '/maryland',
  },
  {
    title: 'Massachusetts',
    url: '/massachusetts',
  },
  {
    title: 'Michigan',
    url: '/michigan',
  },
  {
    title: 'Minnesota',
    url: '/minnesota',
  },
  {
    title: 'Mississippi',
    url: '/mississippi',
  },
  {
    title: 'Missouri',
    url: '/missouri',
  },
  {
    title: 'Montana',
    url: '/montana',
  },
  {
    title: 'Nebraska',
    url: '/nebraska',
  },
  {
    title: 'Nevada',
    url: '/nevada',
  },
  {
    title: 'New Hampshire',
    url: '/new-hampshire',
  },
  {
    title: 'New Jersey',
    url: '/new-jersey',
  },
  {
    title: 'New Mexico',
    url: '/new-mexico',
  },
  {
    title: 'New York',
    url: '/new-york',
  },
  {
    title: 'North Carolina',
    url: '/north-carolina',
  },
  {
    title: 'North Dakota',
    url: '/north-dakota',
  },
  {
    title: 'Ohio',
    url: '/ohio',
  },
  {
    title: 'Oklahoma',
    url: '/oklahoma',
  },
  {
    title: 'Oregon',
    url: '/oregon',
  },
  {
    title: 'Pennsylvania',
    url: '/pennsylvania',
  },
  {
    title: 'Rhode Island',
    url: '/rhode-island',
  },
  {
    title: 'South Carolina',
    url: '/south-carolina',
  },
  {
    title: 'South Dakota',
    url: '/south-dakota',
  },
  {
    title: 'Tennessee',
    url: '/tennessee',
  },
  {
    title: 'Texas',
    url: '/texas',
  },
  {
    title: 'Utah',
    url: '/utah',
  },
  {
    title: 'Vermont',
    url: '/vermont',
  },
  {
    title: 'Virginia',
    url: '/virginia',
  },
  {
    title: 'Washington',
    url: '/washington',
  },
  {
    title: 'West Virginia',
    url: '/west-virginia',
  },
  {
    title: 'Wisconsin',
    url: '/wisconsin',
  },
  {
    title: 'Wyoming',
    url: '/wyoming',
  },
];

export const TOWNHOME_CONDOS_RENTALS = [
  {
    title: 'Albuquerque townhomes for rent',
    url: '/albuquerque-nm/townhomes-for-rent',
  },
  {
    title: 'Baltimore townhomes for rent',
    url: '/baltimore-md/townhomes-for-rent',
  },
  {
    title: 'Chicago townhomes for rent',
    url: '/chicago-il/townhomes-for-rent',
  },
  {
    title: 'Cleveland townhomes for rent',
    url: '/cleveland-oh/townhomes-for-rent',
  },
  {
    title: 'Denver townhomes for rent',
    url: '/denver-co/townhomes-for-rent',
  },
  {
    title: 'Kansas City townhomes for rent',
    url: '/kansas-city-mo/townhomes-for-rent',
  },
  {
    title: 'Phoenix townhomes for rent',
    url: '/phoenix-az/townhomes-for-rent',
  },
  {
    title: 'Portland townhomes for rent',
    url: '/portland-or/townhomes-for-rent',
  },
  {
    title: 'Saint Louis townhomes for rent',
    url: '/saint-louis-mo/townhomes-for-rent',
  },
  {
    title: 'San Diego townhomes for rent',
    url: '/san-diego-ca/townhomes-for-rent',
  },
  {
    title: 'Seattle townhomes for rent',
    url: '/seattle-wa/townhomes-for-rent',
  },
  {
    title: 'Tampa townhomes for rent',
    url: '/tampa-fl/townhomes-for-rent',
  },
  {
    title: 'Washington DC townhomes for rent',
    url: '/washington-dc/townhomes-for-rent',
  },
  {
    title: 'Arlington condos for rent',
    url: '/arlington-va/condos-for-rent',
  },
  {
    title: 'Atlanta condos for rent',
    url: '/atlanta-ga/condos-for-rent',
  },
  {
    title: 'Chicago condos for rent',
    url: '/chicago-il/condos-for-rent',
  },
  {
    title: 'Dallas condos for rent',
    url: '/dallas-tx/condos-for-rent',
  },
  {
    title: 'Denver condos for rent',
    url: '/denver-co/condos-for-rent',
  },
  {
    title: 'Indianapolis condos for rent',
    url: '/indianapolis-in/condos-for-rent',
  },
  {
    title: 'Las Vegas condos for rent',
    url: '/las-vegas-nv/condos-for-rent',
  },
  {
    title: 'Phoenix condos for rent',
    url: '/phoenix-az/condos-for-rent',
  },
  {
    title: 'Portland condos for rent',
    url: '/portland-or/condos-for-rent',
  },
  {
    title: 'Seattle condos for rent',
    url: '/seattle-wa/condos-for-rent',
  },
  {
    title: 'Virginia Beach condos for rent',
    url: '/virginia-beach-va/condos-for-rent',
  },
  {
    title: 'Washington DC condos for rent',
    url: '/washington-dc/condos-for-rent',
  },
];
